import { BrowserAdapter } from './adapter.mjs';

const settings = {
  ADAPTER: BrowserAdapter,
  RESOLUTION: 1,
  RENDER_OPTIONS: {
    view: null,
    width: 800,
    height: 600,
    autoDensity: false,
    backgroundColor: 0,
    backgroundAlpha: 1,
    clearBeforeRender: true,
    antialias: false,
    premultipliedAlpha: true,
    preserveDrawingBuffer: false,
    hello: false
  },
  CREATE_IMAGE_BITMAP: false,
  ROUND_PIXELS: false
};

export { settings };
//# sourceMappingURL=settings.mjs.map
